// Lib
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Styles
import './ToggleButton.scss';

export const TOGGLE_BUTTON_TRANSITION_LENGTH = 160;

const getTransitionStyle = (duration, easing = 'ease-in-out', property) => {
    if (!duration) return;
    return { transition: `${duration}ms ${easing} ${property}` };
};

const ToggleButton = ({ active, noTransition, duration, easing }) => (
    <div className={classNames('ToggleButton', { active, 'no-transition': noTransition })}>
        <div className="toggle-active-background" style={getTransitionStyle(duration, easing, 'opacity')} />
        <div className="toggle-thumb" style={getTransitionStyle(duration, easing, 'transform')} />
    </div>
);

ToggleButton.propTypes = {
    active: PropTypes.bool,
    noTransition: PropTypes.bool,
    // Transition
    duration: PropTypes.number,
    easing: PropTypes.string,
};

export default ToggleButton;
